import React from "react";
import { Img } from "../../../Img";
export const ChartsGridContainer = ({ mainTitle, subTitle, chartsUrl }) => (React.createElement("div", { className: "chartsGridContainerWrapper" },
    React.createElement("h3", { className: "chartsGridContainerWrapper__mainTitle" }, mainTitle),
    React.createElement("h5", { className: "chartsGridContainerWrapper__subTitle" }, subTitle),
    React.createElement("div", { className: "chartsGridContainerWrapper__chartsImageWrapper" },
        React.createElement(Img, { src: chartsUrl, alt: mainTitle }))));
